import { render, staticRenderFns } from "./px-card.vue?vue&type=template&id=2ca0497a&scoped=true&"
import script from "./px-card.vue?vue&type=script&lang=ts&"
export * from "./px-card.vue?vue&type=script&lang=ts&"
import style0 from "./px-card.vue?vue&type=style&index=0&id=2ca0497a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0497a",
  null
  
)

export default component.exports